// extracted by mini-css-extract-plugin
export default {"item-list":"AppetizersDesktop_item-list__TrTZE","item":"AppetizersDesktop_item__wgEd8","section":"AppetizersDesktop_section__lDo6c"};